import {SPHERE} from '../../../models/patient-sphere';

export const BIOCHEMICAL_DATA: SPHERE.ISphereBiochemical[] = [
  {
    name: 'erythrocytes',
    nameEs: 'Eritrocitos',
    value: 0,
    measureUnitSymbolEs: 'millones/uL',
    range: {
      min: 4.50,
      max: 5.40
    }
  },
  {
    name: 'hemoglobin',
    nameEs: 'Hemoglobina',
    value: 0,
    measureUnitSymbolEs: 'gr/dL',
    range: {
      min: 12.00,
      max: 16.00,
    }
  },
  {
    name: 'hematocrit',
    nameEs: 'Hematocrito',
    value: 0,
    measureUnitSymbolEs: '%',
    range: {
      min: 38.00,
      max: 47.00
    }
  },
  {
    name: 'leukocytes',
    nameEs: 'Leucocitos',
    value: 0,
    measureUnitSymbolEs: 'miles/uL',
    range: {
      min: 3.84,
      max: 9.79
    }
  },
  {
    name: 'lymphocytes',
    nameEs: 'Linfocitos',
    value: 0,
    measureUnitSymbolEs: '%',
    range: {
      min: 15.50,
      max: 48.6
    }
  },
  {
    name: 'serum_creatinine',
    nameEs: 'Creatinina serica ',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 4.20,
      max: 46.00
    }
  },
  {
    name: 'serum_urea',
    nameEs: 'Urea serica',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 16.00,
      max: 46.00
    }
  },
  {
    name: 'urea_nitrogen',
    nameEs: 'Nitrogeno de la urea',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 7,
      max: 18
    }
  },
  {
    name: 'uric_acid',
    nameEs: 'Ácido urico',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 3.5,
      max: 7.2
    }
  },
  {
    name: 'sodium',
    nameEs: 'Sodio',
    value: 0,
    measureUnitSymbolEs: 'mmol/L',
    range: {
      min: 136,
      max: 145
    }
  },
  {
    name: 'potassium',
    nameEs: 'Potasio',
    value: 0,
    measureUnitSymbolEs: 'mmol/L',
    range: {
      min: 3.5,
      max: 5.1
    }
  },
  {
    name: 'calcium',
    nameEs: 'calcio',
    value: 0,
    measureUnitSymbolEs: 'ng/dL',
    range: {
      min: 8.5,
      max: 10.1
    }
  },
  {
    name: 'chlorine',
    nameEs: 'Cloro',
    value: 0,
    measureUnitSymbolEs: 'mmol/L',
    range: {
      min: 98,
      max: 107
    }
  },
  {
    name: 'serum_magnesium',
    nameEs: 'Magnesio serico',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 1.8,
      max: 2.4
    }
  },
  {
    name: 'glucose',
    nameEs: 'Glucosa',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 74,
      max: 106
    }
  },
  {
    name: 'phosphorus',
    nameEs: 'Fosforo',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 2.6,
      max: 4.7
    }
  },
  // Mini sphere
  {
    name: 'glucose',
    nameEs: 'Glucosa',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'cholesterol',
    nameEs: 'Colesterol',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'tg',
    nameEs: 'Triglicéridos',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'hdl',
    nameEs: 'Lipoproteínas de alta densidad',
    value: 0,
    measureUnitSymbolEs: 'mg/dL',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'ldl',
    nameEs: 'Lipoproteínas de baja densidad',
    value: 0,
    measureUnitSymbolEs: 'md/dL',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'hbGlic',
    nameEs: 'Hemoglobina glicosilada',
    value: 0,
    measureUnitSymbolEs: '%',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'insulin',
    nameEs: 'Insulina',
    value: 0,
    measureUnitSymbolEs: 'mU/L',
    range: {
      min: 0,
      max: 0,
    }
  },
  {
    name: 'vitaminD3',
    nameEs: 'Vitamina D3',
    value: 0,
    measureUnitSymbolEs: 'ng/mL',
    range: {
      min: 0,
      max: 0,
    }
  },
];
